export const home_nav_content1 = "Office";
export const home_nav_content2 = "Works";
export const home_nav_content3 = "News";
export const home_nav_content4 = "Contact";
export const home_dropdown_content1 = "Featured";
export const home_dropdown_content2 = "Hospitality";
export const home_dropdown_content3 = "Homes";
export const home_dropdown_content4 = "Workplaces";
export const home_dropdown_content5 = "Housing";
export const home_dropdown_content6 = "Mixed Use";
export const home_dropdown_content7 = "Master Planning";
export const home_dropdown_content8 = "Institutions";
export const home_dropdown_content9 = "Exhibits";
export const footer_contactNo = "+91 22 666 33 555";
export const footer_address =
  " 601 Lodha Supremus, Senapati Bapat Marg, Lower Parel, Mumbai 400013, India.";
export const footer_mail = "info@se-arch.com";
export const footer_copyrights =
  "Copyright © 2024 Se-Arch. All rights reserved.";
export const news_subnav_content1 = "Press Release";
export const news_subnav_content2 = "Videos";
export const news_subnav_content3 = "Publications";
export const news_subnav_content4 = "Thoughts & Ideas";
export const newsview_title = "Latest Press Release";
export const newsview_fig_caption =
  "Sky Project and M House Awarded by SARA NY as Modern Architecture of India.";
export const newsview_fig_caption_date = "22 Feb, 2024";
export const news_sidebar_title = "Subscribe to Newsletter";
export const news_subscribe_btn = "Subscribe";
export const news_updates_title = "Updates";
export const contact_subnav_content1 = "Send Enquiry";
export const contact_subnav_content2 = "Career";
export const contact_subnav_content3 = "Downloads";
export const contact_phone_text = "Phone:";
export const contact_location_text = "Location:";
export const contact_Email_text = "Email:";
export const contact_follow_us_text = "Follows Us";
export const contact_enquiry_subtitle = "Reach out to us for any inquiry";
export const contact_enquiry_form_submit_btn = "Submit Enquiry";
